export default __webpack_public_path__ + "static/media/video-2.f775450d.mp4";